import { Component, ViewChild } from '@angular/core';
import { NotificationService } from '../notification/notification.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { ConfirmDialogService } from '../confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-stock-snapshots',
  templateUrl: './stock-snapshots.component.html',
  styleUrl: './stock-snapshots.component.scss'
})
export class StockSnapshotsComponent {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<any>;
  fetching: boolean = false;
  displayedColumns: string[] = ['timestamp','remove'];
  creating: boolean = false;
  constructor(
    private http: HttpClient,
    private notificationService: NotificationService,
    private confirmDialog: ConfirmDialogService
  ) {
    this.dataSource = new MatTableDataSource<any>();
  }

  ngOnInit(): void {
    this.fetchSnapshots();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  fetchSnapshots() {
    this.fetching = true;
    this.http.get(`transactions/stock-snapshots`).subscribe((response: any) => {
      this.dataSource.data = response;
      this.fetching = false;
    }, (error: any) => {
      this.notificationService.show("Hiba a készlet snapshotok lekérdezése során", "danger");
      this.fetching = false;
    })
  }

  remove(timestamp: Date) {
    this.confirmDialog.open({
      title: 'Készlet snapshot törlése',
      message: 'Biztosan törölni szeretnéd ezt a készlet snapshotot?',
      details: 'A törölt snapshot később nem állítható vissza.',
      confirmLabel: 'Törlés',
      tone: 'danger',
      icon: 'fa-solid fa-trash'
    }).subscribe((result) => {
      if (!result?.confirmed) {
        return;
      }
      this.http.delete(`transactions/stock-snapshots?ts=${timestamp}`).subscribe((response: any) => {
        if(response === 0) {
          this.notificationService.show("Hiba a készlet snapshot törlése során", "danger");
          return;
        }
        this.fetchSnapshots();
        this.notificationService.show("Készlet snapshot sikeresen törölve!", "success");
      }, (error: any) => {
        this.notificationService.show("Hiba a készlet snapshot törlése során", "danger");
        console.error(error);
      });
    });
  }

  createNewSnapshot() {
    this.confirmDialog.open({
      title: 'Készlet snapshot készítése',
      message: 'Elmented a jelenlegi készletállapotot új snapshotként?',
      details: 'A rendszer időbélyeggel rögzíti az aktuális készletszinteket.',
      confirmLabel: 'Snapshot készítése',
      tone: 'primary',
      icon: 'fa-solid fa-camera-retro'
    }).subscribe((result) => {
      if (!result?.confirmed) {
        return;
      }
      this.creating = true;
      this.http.post(`transactions/stock-snapshots`, {}).subscribe((response: any) => {
        console.log(response);
        this.fetchSnapshots();
        this.creating = false;
        this.notificationService.show("Készlet snapshot sikeresen létrehozva!", "success");
      }, (error: any) => {
        this.notificationService.show("Hiba a készlet snapshot létrehozása során", "danger");
        console.error(error);
        this.creating = false;
      });
    });
  }

}
